import { render, staticRenderFns } from "./MngtRedirect.vue?vue&type=template&id=e560ab24&scoped=true&"
import script from "./MngtRedirect.vue?vue&type=script&lang=js&"
export * from "./MngtRedirect.vue?vue&type=script&lang=js&"
import style0 from "./MngtRedirect.vue?vue&type=style&index=0&id=e560ab24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e560ab24",
  null
  
)

export default component.exports